module.exports = __webpack_public_path__ + "images/category_lp/pc/lp-pc-shop-image1_203e14fedb00a05efe0f402505cf1170.png";